// Mostly a wrapper for the ba-tech CanvasImage methods so that we can share
// one image cache.

const Shortvas = require("shortvas");
const CanvasUtil = require("./CanvasUtil");
const {
	CanvasImage: BaTechCanvasImage,
} = require("@aops-trove/ba-tech/bao_utils");

// extend the BAO shortvas with the ba-tech canvas image methods
const improveShortvasDrawImage = function() {
	const sampleShortvas = CanvasUtil.getShortvas(
		CanvasUtil.getTransientContext()
	);
	Shortvas.extend({
		drawImage: BaTechCanvasImage.makeBetterDrawImage(sampleShortvas.drawImage),
	});
};

module.exports = {
	improveShortvasDrawImage,
	makeBetterDrawImage: BaTechCanvasImage.makeBetterDrawImage,
	withLoading: BaTechCanvasImage.withLoading,
	withLoadingForTemp: BaTechCanvasImage.withLoadingForTemp,
	hasSomeUnloaded: BaTechCanvasImage.hasSomeUnloaded,
	isBrokenCanvas: BaTechCanvasImage.isBrokenCanvas,
};
